import ObserveNode from "./ObserveNode";

export default class TransformNode extends ObserveNode {
  init() {}

  addPredecessor(node) {
    this.pred.push(node);
    if (!this.isSink() && this.active) node.addSuccessor(this);
  }

  handleSuccInc(node) {
    if (this.isSink() && this.active) this.startObserving();
  }

  handleSuccDec(node) {
    if (this.isSink()) this.stopObserving();
  }

  activate() {
    this.active = true;
    if (!this.isSink()) this.startObserving();
  }
}
